import { render } from "./ChallengeView.vue?vue&type=template&id=74373071&scoped=true"
import script from "./ChallengeView.vue?vue&type=script&lang=js"
export * from "./ChallengeView.vue?vue&type=script&lang=js"

import "./ChallengeView.vue?vue&type=style&index=0&id=74373071&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
import "./ChallengeView.vue?vue&type=style&index=2&id=74373071&lang=css"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74373071"]])

export default __exports__